import { ChevronsLeft, ChevronsRight } from 'lucide-react'
import styled from 'styled-components'

export const PanelContainer = styled.div`
  width: 20rem;
  height: 80vh;
  background-color: ${({ theme }) => theme.forecast.background3};
  border: 1px solid ${({ theme }) => theme.forecast.border};
  padding: 1rem;
  overflow-y: auto;
  border-radius: 1rem;
`

export const PanelHeader = styled.h1`
  font-size: 1.5rem;
  font-weight: 600;
  color: ${({ theme }) => theme.forecast.activeText};
  margin-bottom: 1.5rem;
  padding-bottom: 0.5rem;
`

export const FormSection = styled.div`
  margin-bottom: 1.5rem;
`

export const SectionTitle = styled.div`
  font-size: 0.875rem;
  font-weight: 500;
  color: ${({ theme }) => theme.forecast.secondaryText};
  margin-bottom: 0.75rem;
  border-bottom: 1px solid ${({ theme }) => theme.forecast.border};
`

export const InputRow = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
`

export const InputColumn = styled.div`
  flex: 1;
`

export const PercentageControls = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`

export const PercentageDisplay = styled.div`
  min-width: 3rem;
  text-align: center;
  font-weight: 500;
  color: ${({ theme }) => theme.forecast.activeText};
  font-size: 0.875rem;
`

export const rotationOptions = [
  { value: '0', label: '0°' },
  { value: '90', label: '90°' },
  { value: '180', label: '180°' },
  { value: '270', label: '270°' },
]

export const ChevronLeftIcon = styled(ChevronsLeft)`
  transform: scaleY(3) scaleX(1.2);
`

export const ChevronRightIcon = styled(ChevronsRight)`
  transform: scaleY(3) scaleX(1.2);
`

export const PanelWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;
  min-height: 80vh;
`

export const PanelPlaceholder = styled.div`
  min-height: 80vh;
`

export const ToggleButton = styled.button`
  position: absolute;
  left: -1.5rem;
  top: 50%;
  transform: translateY(-50%);

  width: 1.5rem;
  height: 5rem;
  border: 1px solid ${({ theme }) => theme.forecast.border};
  border-radius: 1rem 0 0 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
`

export const ColorInputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const ColorInput = styled.input`
  width: 3rem;
  height: 2rem;
  border: 1px solid ${({ theme }) => theme.forecast.border};
  border-radius: 0.25rem;
  cursor: pointer;
  padding: 0;
  background: transparent;

  &::-webkit-color-swatch-wrapper {
    padding: 2px;
  }

  &::-webkit-color-swatch {
    border-radius: 0.25rem;
    border: none;
  }
`

export const ColorHexInput = styled.input`
  flex: 1;
  padding: 0.5rem;
  border: 1px solid ${({ theme }) => theme.forecast.border};
  border-radius: 0.25rem;
  background: ${({ theme }) => theme.forecast.background2};
  color: ${({ theme }) => theme.forecast.activeText};
  font-size: 0.875rem;

  &::placeholder {
    color: ${({ theme }) => theme.forecast.secondaryText};
  }
`

export const MetadataContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const MetadataRow = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`

export const MetadataInput = styled.input`
  flex: 1;
  min-width: 0;
  padding: 0.5rem;
  border: 1px solid ${({ theme }) => theme.forecast.border};
  border-radius: 0.25rem;
  background: ${({ theme }) => theme.forecast.background2};
  color: ${({ theme }) => theme.forecast.activeText};
  font-size: 0.875rem;

  &::placeholder {
    color: ${({ theme }) => theme.forecast.secondaryText};
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`

export const MetadataRemoveButton = styled.button`
  flex-shrink: 0;
  width: 1.75rem;
  height: 1.75rem;
  padding: 0;
  border: 1px solid ${({ theme }) => theme.forecast.border};
  border-radius: 0.25rem;
  background: transparent;
  color: ${({ theme }) => theme.forecast.secondaryText};
  cursor: pointer;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: ${({ theme }) => theme.forecast.background2};
    color: ${({ theme }) => theme.forecast.activeText};
  }
`

export const AddMetadataButton = styled.button`
  padding: 0.5rem;
  border: 1px dashed ${({ theme }) => theme.forecast.border};
  border-radius: 0.25rem;
  background: transparent;
  color: ${({ theme }) => theme.forecast.secondaryText};
  cursor: pointer;
  font-size: 0.875rem;
  width: 100%;
  text-align: center;

  &:hover {
    background: ${({ theme }) => theme.forecast.background2};
    color: ${({ theme }) => theme.forecast.activeText};
  }
`

export const labelPositionOptions = [
  { value: 'top', label: 'Top' },
  { value: 'bottom', label: 'Bottom' },
  { value: 'left', label: 'Left' },
  { value: 'right', label: 'Right' },
  { value: 'center', label: 'Center' },
]

export const shapeStyleOptions = [
  { value: 'outlined', label: 'Outlined' },
  { value: 'filled', label: 'Filled' },
  { value: 'dashed', label: 'Dashed' },
  { value: 'dotted', label: 'Dotted' },
]
